import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {catchError, Observable, of} from 'rxjs';
import {TokenService} from "@core/services/token.service";
import {AuthenticationService} from "@core/authentication/services/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
    private router:Router,
    private tokenService: TokenService,
    private authenticationService: AuthenticationService
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> |
    boolean | UrlTree {
      
      const currentTenant = this.tokenService.getTenant()
      const requiredGrants = route.data['requiredGrants'] as Array<string>;
      const alternativeGrants = route.data['alternativeGrants'] as Array <string>;
      const hasSession = !!sessionStorage.getItem('tracr')

      // Tiene acceso a todas las pestañas
      const userGrants = this.tokenService.userGrantsInOrganization();
      if (userGrants.includes('ALL')) {
        this.tokenService.getWholeOrganizations()
        return true;
      }
      
      
      // Acceso para una ruta específica
      if ((this.tokenService.tokenHasAnyGrant(currentTenant, alternativeGrants) || this.tokenService.tokenHasGrant(currentTenant, requiredGrants)) && hasSession) {
        this.tokenService.getWholeOrganizations()
        return true;
      }
      
      const hasBasicAccess = this.tokenService.tokenHasAnyGrant(currentTenant, ['LTW'])

      if(hasBasicAccess) {
        this.router.navigate(['/home'])
        return false
      }

      this.authenticationService.logout()
        .pipe(
          catchError((error) => {
            console.log(error);
            return of(null);
          })
        ).subscribe((data) => {
        this.router.navigate(['/auth/login']).then(r => console.log(r));
      });
      return false;
  }
}
